<div class="grid">
    <div class="col-12">
        <div class="card" *ngIf="!permissaoInserir">
            <div style="text-align: center">
                <h4>Você não possui permissão de acesso essa página!</h4>
            </div>
        </div>
        <div class="card" *ngIf="permissaoInserir">
            <form #f="ngForm" name="form" novalidate (ngSubmit)="salvar()">
                <div class="formgroup">
                    <div class="p-fluid p-formgrid grid mb-3">
                        <div *ngIf="messagemVisivel" class="field col-12 md:col-12">
                            <p-messages
                                [(value)]="messages"
                                [enableService]="false"
                                [closable]="true"
                            ></p-messages>
                        </div>
                        <div class="field col-12 md:col-4">
                            <label htmlFor="profissionalId">Profissional</label>
                            <p-dropdown
                                [options]="profissionais"
                                optionLabel="usuario.nome"
                                [filter]="true"
                                emptyFilterMessage="Nenhum registro"
                                placeholder="Selecione"
                                ngModel
                                #profissionalId="ngModel"
                                [required]="true"
                                [(ngModel)]="profissionalSelecionado"
                                [ngModelOptions]="{ standalone: true }"
                            ></p-dropdown>
                        </div>
                        <div class="field col-12 md:col-4">
                            <label htmlFor="codigoPlanoConta">Referente</label>
                            <p-dropdown
                                [options]="contas"
                                optionLabel="descricao"
                                optionValue="codigo"
                                [filter]="true"
                                emptyFilterMessage="Nenhum registro"
                                placeholder="Selecione"
                                name="codigoPlanoConta"
                                ngModel
                                #codigoPlanoConta="ngModel"
                                [required]="true"
                            ></p-dropdown>
                        </div>
                        <div class="field col-12 md:col-4">
                            <label htmlFor="descricao">Descrição</label>
                            <input
                                type="text"
                                pInputText
                                placeholder="Digita descrição"
                                name="descricao"
                                ngModel
                                #descricao="ngModel"
                            />
                        </div>
                        <div class="field col-12 md:col-2">
                            <label htmlFor="dataRegistro">Data Registro</label>
                            <p-calendar
                                [(ngModel)]="registro"
                                [readonlyInput]="false"
                                [showIcon]="true"
                                dateFormat="dd/mm/yy"
                                [showButtonBar]="true"
                                name="dataRegistro"
                                ngModel
                                #dataRegistro="ngModel"
                                [required]="true"
                            ></p-calendar>
                        </div>
                        <div class="field col-12 md:col-2">
                            <label htmlFor="dataCompetencia">Competência</label>
                            <p-calendar
                                placeholder="Selecione"
                                view="month"
                                dateFormat="mm/yy"
                                [showIcon]="true"
                                [readonlyInput]="true"
                                name="dataCompetencia"
                                ngModel
                                #dataCompetencia="ngModel"
                            ></p-calendar>
                        </div>
                        <div class="field col-12 md:col-2">
                            <label htmlFor="valorRegistro">Valor</label>
                            <p-inputNumber
                                name="valorRegistro"
                                ngModel
                                #valorRegistro="ngModel"
                                mode="currency"
                                inputId="currency-brazil"
                                currency="BRL"
                                locale="pt-BR"
                                [allowEmpty]="true"
                                [required]="true"
                                [(ngModel)]="valorRegistroDigitado"
                            ></p-inputNumber>
                            <div
                                *ngIf="
                                    (valorRegistro.touched && valorRegistro.value <= 0) ||
                                    (valorRegistro.value <= 0 && exibirMensagem)
                                "
                                class="alerta"
                            >
                                <small>Deve ser maior que zero</small>
                            </div>
                        </div>
                    </div>
                    <div class="p-fluid p-formgrid grid justify-content-between">
                        <div class="col-12 md:col-4">
                            <button
                                type="submit"
                                pButton
                                [icon]="
                                    progressoRequisicao ? 'pi pi-spin pi-spinner' : 'pi pi-check'
                                "
                                label="Salvar"
                                class="p-button-outlined p-button-success md:w-9rem"
                                [disabled]="
                                    f.invalid || valorRegistroDigitado <= 0 || progressoRequisicao
                                "
                            ></button>
                        </div>
                        <div class="col-12 md:col-4 flex justify-content-end">
                            <button
                                type="button"
                                pButton
                                icon="pi pi-arrow-left"
                                label="Voltar"
                                class="p-button-outlined md:w-9rem"
                                routerLink="/apps/adicionais-e-descontos"
                            ></button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
